import type { Product } from "@jti/magento";

export const getGiftItemsFromCart = (items: Product[], giftSku: string, parentId: string): Product[] => {
  return items.filter((item) => item.isGift === true && item.sku === giftSku && item.parentGiftId === parentId);
};
